<template>
  <div class="modal fade" id="noteModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered  w-[400px] ">
          <div class="modal-content">
              <Form @submit="onUpdate" >

                  <div class="modal-header">
                      <h1 class="modal-title fs-5">Add or Update Note</h1>
                      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                  </div>
                  <div class="modal-body" v-if="props.license">
                      <div class="text-sm  pt-4 space-y-2">
                          <Field name="note" >
                              <div class="relative">
                                  <textarea v-model="note"
                                      class=" form-control shadow-none rounded-0 text-black" />
                              </div>
                          </Field>
                      </div>
                  </div>
                  <div class="modal-footer">
                      <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                      <button type="submit" :disabled="buttonDisableFlag" class="btn btn-primary">Update</button>
                  </div>
              </Form>
          </div>
      </div>
  </div>
</template>
<script setup>
import { ref, watch, defineProps, defineEmits, watchEffect } from 'vue';
import { Form, Field } from 'vee-validate';

import {useProxyStore} from "@/stores"
const proxyStore = useProxyStore()
const buttonDisableFlag = ref(false)
const props = defineProps({
  license: {
      type: Object, // Assuming user object has a name property
      required: true
  },
});
const note = ref('')
watch(() => props.license, (newvalue) => {
  if(newvalue) {
    note.value = newvalue.note
  }
})
const onUpdate = ( (values) => {
  // const {note} = values;
  buttonDisableFlag.value = true;
  proxyStore.updateNote(props.license.uuid, note.value).then(res=>{
      buttonDisableFlag.value = false
      emit('close');
  })
});
const emit = defineEmits(['inInput', 'submit'])
</script>